import NotFound from './NotFound.page';
export default NotFound;
